export default ({
  FORMS_SET_FIELD                 : 'FORMS_SET_FIELD',
  FORMS_DEL_FIELD                 : 'FORMS_DEL_FIELD',
  FORMS_SET_GROUP_FIELD           : 'FORMS_SET_GROUP_FIELD',
  FORMS_MANAGER_FIELDS            : 'FORMS_MANAGER_FIELDS',
  FORMS_SET_UPDATE_FORM_BY_FIELD  : 'FORMS_SET_UPDATE_FORM_BY_FIELD',

  CONTEXT_REDIRECT_PERFIL_CONFIG_MEDICALRECORD_FORMS : 'HS6sM0wAnIrvgntzKBjHVewp4kvzmDddYyiVk6iZzjJrPvQwXMFbus3XqKmaN2G748tTNzTMOMXvmsiicYf4EQ',
  CONTEXT_REDIRECT_CONFIG_MEDICALRECORD_FORMS: 'HS6sM0wAnIrvgntzKBjHVetDDFNAceShABGYVcbKkUO2pF6vQL0CymQu0w5HVAvD'
});